import { DSCardWrapper } from "../molecules";

export const AtomsSection = () => {
  return (
    <>
      {/* Color Palette Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Color Palette</h2>

        <DSCardWrapper dataTestId="ds-test-atoms-colors-card">
          {/* Semantic Colors */}
          <div className="mb-lg">
            <h3>Semantic Colors (Auto Light/Dark Mode)</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-lg">
              <div>
                <div className="bg-primary border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-primary</p>
              </div>
              <div>
                <div className="bg-secondary border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-secondary</p>
              </div>
              <div>
                <div className="bg-tertiary border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-tertiary</p>
              </div>
              <div>
                <div className="bg-brand border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-brand</p>
              </div>
              <div>
                <div className="bg-success border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-success</p>
              </div>
              <div>
                <div className="bg-warning border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-warning</p>
              </div>
              <div>
                <div className="bg-danger border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-danger</p>
              </div>
              <div>
                <div className="bg-disabled border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-disabled</p>
              </div>
              <div>
                <div className="bg-subjective border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-subjective</p>
              </div>
              <div>
                <div className="bg-objective border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-objective</p>
              </div>
              <div>
                <div className="bg-assessment border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-assessment</p>
              </div>
              <div>
                <div className="bg-plan border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-plan</p>
              </div>
            </div>
          </div>

          {/* Subtle Variants */}
          <div>
            <h3>Subtle Variants (20% opacity)</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-lg">
              <div>
                <div className="bg-brand-subtle border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-brand-subtle</p>
              </div>
              <div>
                <div className="bg-success-subtle border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-success-subtle</p>
              </div>
              <div>
                <div className="bg-warning-subtle border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-warning-subtle</p>
              </div>
              <div>
                <div className="bg-danger-subtle border border-primary h-20 rounded-standard mb-sm" />
                <p>bg-danger-subtle</p>
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Typography Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Typography</h2>

        <DSCardWrapper dataTestId="ds-test-atoms-typography-card">
          <p className="mb-lg">
            Examples below show explicit classes for demonstration. In
            practice, use semantic HTML without classes unless
            overriding defaults.
          </p>

          <div className="space-y-md">
            <div>
              <h1 className="font-title font-extrabold text-4xl text-primary">
                Heading 1 - 36px
              </h1>
              <p>font-title font-extrabold text-4xl</p>
            </div>
            <div>
              <h2 className="font-title font-bold text-3xl text-primary">
                Heading 2 - 30px
              </h2>
              <p>font-title font-bold text-3xl</p>
            </div>
            <div>
              <h3 className="font-title font-bold text-2xl text-primary">
                Heading 3 - 24px
              </h3>
              <p>font-title font-bold text-2xl</p>
            </div>
            <div>
              <h4 className="font-title font-semibold text-lg text-primary">
                Heading 4 - 18px
              </h4>
              <p>font-title font-semibold text-lg</p>
            </div>
            <div>
              <h5 className="font-body font-semibold text-base text-primary">
                Heading 5 - 16px
              </h5>
              <p>font-body font-semibold text-base</p>
            </div>
            <div>
              <p>Paragraph - 14px</p>
              <p>font-body font-normal text-sm</p>
            </div>
            <div>
              <p>Small Text - 12px</p>
              <p>font-body font-normal text-xs</p>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Spacing Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Spacing Scale</h2>

        <DSCardWrapper dataTestId="ds-test-atoms-spacing-card">
          <div className="space-y-md">
            <div className="flex items-center gap-lg">
              <div className="w-32 text-sm text-secondary">
                p-xs (4px)
              </div>
              <div className="p-xs bg-brand rounded-minimal">
                <div className="bg-secondary w-16 h-8" />
              </div>
            </div>
            <div className="flex items-center gap-lg">
              <div className="w-32 text-sm text-secondary">
                p-sm (8px)
              </div>
              <div className="p-sm bg-brand rounded-minimal">
                <div className="bg-secondary w-16 h-8" />
              </div>
            </div>
            <div className="flex items-center gap-lg">
              <div className="w-32 text-sm text-secondary">
                p-md (16px)
              </div>
              <div className="p-md bg-brand rounded-minimal">
                <div className="bg-secondary w-16 h-8" />
              </div>
            </div>
            <div className="flex items-center gap-lg">
              <div className="w-32 text-sm text-secondary">
                p-lg (32px)
              </div>
              <div className="p-lg bg-brand rounded-minimal">
                <div className="bg-secondary w-16 h-8" />
              </div>
            </div>
            <div className="flex items-center gap-lg">
              <div className="w-32 text-sm text-secondary">
                p-xl (64px)
              </div>
              <div className="p-xl bg-brand rounded-minimal">
                <div className="bg-secondary w-16 h-8" />
              </div>
            </div>
          </div>

          <div className="mt-lg p-md bg-secondary rounded-standard">
            <h4 className="mb-sm">Larger Spacing</h4>
            <p>
              For spacing larger than 64px, use Tailwind's numeric
              scale (4px per unit):
            </p>
            <div className="space-y-sm text-sm font-companion">
              <div>
                <code className="text-brand">p-24</code>{" "}
                <span className="text-secondary">(96px)</span>
              </div>
              <div>
                <code className="text-brand">p-32</code>{" "}
                <span className="text-secondary">(128px)</span>
              </div>
              <div>
                <code className="text-brand">p-40</code>{" "}
                <span className="text-secondary">(160px)</span>
              </div>
              <div>
                <code className="text-brand">p-48</code>{" "}
                <span className="text-secondary">(192px)</span>
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Border Radius Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Border Radius</h2>

        <DSCardWrapper dataTestId="ds-test-atoms-radius-card">
          <div className="flex flex-wrap gap-lg">
            <div className="text-center">
              <div className="bg-brand w-24 h-24 rounded-minimal mb-sm" />
              <p className="text-sm text-secondary">
                rounded-minimal (4px)
              </p>
            </div>
            <div className="text-center">
              <div className="bg-brand w-24 h-24 rounded-standard mb-sm" />
              <p className="text-sm text-secondary">
                rounded-standard (12px)
              </p>
            </div>
            <div className="text-center">
              <div className="bg-brand w-24 h-24 rounded-large mb-sm" />
              <p className="text-sm text-secondary">
                rounded-large (16px)
              </p>
            </div>
            <div className="text-center">
              <div className="bg-brand w-24 h-24 rounded-full mb-sm" />
              <p className="text-sm text-secondary">rounded-full</p>
            </div>
          </div>
        </DSCardWrapper>
      </section>
    </>
  );
};
